import React from 'react';

import type { LensCardType, LensComputedTemplate, LensValueFormat } from '~/types/leLens';

import { computeReading } from '../readings/computedReading';

import type { Block, Envelope, EnvelopeColumn } from './types';

const formatOf = (column: EnvelopeColumn | undefined): LensValueFormat | undefined => column ? { kind: column.format === 'pct' ? 'percent' : column.format === 'aud' || column.format === 'usd' ? 'currency' : 'number', ...(column.format === 'pct' ? { percentScale: 'unit' as const } : {}), ...(column.format === 'aud' || column.format === 'usd' ? { currency: column.format === 'aud' ? 'AUD' : 'USD' } : {}), ...(column.decimals !== undefined ? { decimals: column.decimals } : {}) } : undefined;

function readingOf(block: Block, envelope: Envelope) {
  const settings = block.reading as { type: LensCardType; template?: LensComputedTemplate; measure?: string; dimension?: string; series?: string; isRatio?: boolean; limited?: boolean };
  const columns = envelope.columns.map((column) => column.name);
  const comparison = envelope.period.comparisons[0];
  const leaves = (rows: Envelope['rows']) => rows.filter((row) => row.level === undefined || row.level === envelope.columns.filter((column) => column.role === 'dim').length);
  const reading = computeReading({
    ...settings,
    shaped: { columns, rows: leaves(envelope.rows) },
    ...(comparison ? { comparison: { label: comparison.label, shaped: { columns, rows: leaves(envelope.compare[comparison.id] ?? []) } } } : {}),
    formatFor: (name) => formatOf(envelope.columns.find((column) => column.name === name)),
    dateRange: envelope.period.current,
  });
  return reading;
}

export function aboutOf(block: Block, envelope?: Envelope): Array<string> {
  const reading = block.reading && envelope ? readingOf(block, envelope) : undefined;
  return [typeof block.description === 'string' ? block.description : '', reading ? (reading.kind === 'reading' ? reading.text : reading.reason) : ''].filter(Boolean);
}

export default function Reading({ block, envelope }: { block: Block; envelope?: Envelope }) {
  const about = aboutOf(block, envelope);
  return about.length ? (
    <details className="bd">
      <summary>About this chart</summary>
      {about.map((text) => (
        <p key={text}>{text}</p>
      ))}
    </details>
  ) : null;
}
